package org.junqueira.portfolio.data

import androidx.compose.runtime.compositionLocalOf

enum class Language {
    EN, PT
}

val LocalLanguage = compositionLocalOf { Language.EN }
